// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  display: flex;
  min-height: 100vh;
  background: #f8f9fa;
}

/* Sidebar Styles */
.sidebar {
  width: 250px;
  background: #2c3e50;
  color: white;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}

.sidebar-header {
  padding: 1.5rem;
  border-bottom: 1px solid #34495e;
}

.sidebar-header h2 {
  margin-bottom: 0.5rem;
  color: white;
}

.user-role {
  background: #3498db;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.7rem;
  text-transform: uppercase;
  font-weight: bold;
}

.sidebar-nav {
  flex: 1 1;
  padding: 1rem 0;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  color: #bdc3c7;
  text-decoration: none;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
}

.nav-item:hover {
  background: #34495e;
  color: white;
}

.nav-item-active {
  background: #34495e;
  color: white;
  border-left-color: #3498db;
}

.nav-icon {
  margin-right: 0.75rem;
  font-size: 1.1rem;
}

.nav-label {
  font-weight: 500;
}

.sidebar-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #34495e;
}

.user-info {
  margin-bottom: 1rem;
}

.username {
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.user-email {
  font-size: 0.8rem;
  color: #bdc3c7;
}

.logout-btn {
  width: 100%;
  padding: 0.5rem;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s ease;
}

.logout-btn:hover {
  background: #c0392b;
}

/* Main Content Styles */
.layout-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0; /* Prevent flex overflow */
}

.layout-header {
  background: white;
  padding: 1rem 2rem;
  border-bottom: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.sidebar-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;
}

.page-title {
  color: #333;
  margin: 0;
  font-size: 1.8rem;
}

.main-content {
  flex: 1 1;
  padding: 2rem;
  overflow-y: auto;
}

/* Loading State */
.layout-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f8f9fa;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 1000;
    transform: translateX(-100%);
  }

  .sidebar-open {
    transform: translateX(0);
  }

  .sidebar-toggle {
    display: block;
  }

  .layout-header {
    padding: 1rem;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .main-content {
    padding: 1rem;
  }
}

/* Mobile Backdrop */
@media (max-width: 768px) {
  .sidebar-open::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 999;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,YAAY;EACd;AACF","sourcesContent":[".layout {\n  display: flex;\n  min-height: 100vh;\n  background: #f8f9fa;\n}\n\n/* Sidebar Styles */\n.sidebar {\n  width: 250px;\n  background: #2c3e50;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.3s ease;\n}\n\n.sidebar-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid #34495e;\n}\n\n.sidebar-header h2 {\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.user-role {\n  background: #3498db;\n  padding: 0.2rem 0.5rem;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 1rem 0;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1.5rem;\n  color: #bdc3c7;\n  text-decoration: none;\n  border-left: 3px solid transparent;\n  transition: all 0.3s ease;\n}\n\n.nav-item:hover {\n  background: #34495e;\n  color: white;\n}\n\n.nav-item-active {\n  background: #34495e;\n  color: white;\n  border-left-color: #3498db;\n}\n\n.nav-icon {\n  margin-right: 0.75rem;\n  font-size: 1.1rem;\n}\n\n.nav-label {\n  font-weight: 500;\n}\n\n.sidebar-footer {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #34495e;\n}\n\n.user-info {\n  margin-bottom: 1rem;\n}\n\n.username {\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.user-email {\n  font-size: 0.8rem;\n  color: #bdc3c7;\n}\n\n.logout-btn {\n  width: 100%;\n  padding: 0.5rem;\n  background: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.3s ease;\n}\n\n.logout-btn:hover {\n  background: #c0392b;\n}\n\n/* Main Content Styles */\n.layout-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; /* Prevent flex overflow */\n}\n\n.layout-header {\n  background: white;\n  padding: 1rem 2rem;\n  border-bottom: 1px solid #dee2e6;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.sidebar-toggle {\n  display: none;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #333;\n}\n\n.page-title {\n  color: #333;\n  margin: 0;\n  font-size: 1.8rem;\n}\n\n.main-content {\n  flex: 1;\n  padding: 2rem;\n  overflow-y: auto;\n}\n\n/* Loading State */\n.layout-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: #f8f9fa;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100vh;\n    z-index: 1000;\n    transform: translateX(-100%);\n  }\n\n  .sidebar-open {\n    transform: translateX(0);\n  }\n\n  .sidebar-toggle {\n    display: block;\n  }\n\n  .layout-header {\n    padding: 1rem;\n  }\n\n  .page-title {\n    font-size: 1.5rem;\n  }\n\n  .main-content {\n    padding: 1rem;\n  }\n}\n\n/* Mobile Backdrop */\n@media (max-width: 768px) {\n  .sidebar-open::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0,0,0,0.5);\n    z-index: 999;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
